<template>
  <el-drawer
    :visible.sync="vModel"
    :with-header="false"
    direction="ltr"
    size="20rem">
    <a
      class="logo">
      <img
        src="/static/img/CMK_Logo.png" />
    </a>
    <Menu />
  </el-drawer>
</template>

<script>
import vModel from '@/utils/mixins/vModel';
import Menu from './Menu/index.vue'
export default {
  data () {
    return {
    }
  },
  mixins: [vModel],
  components: {
    Menu
  }
}
</script>

<style lang="scss" scoped>
>>> .el-drawer__body{
  padding: 0;
  display: flex;
  flex-direction: column;
}
.logo{
  padding: 1.5rem 0 1rem 2rem;
  img{
    max-width: 80%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Sidebar/index.vue